import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';
import { Container, RegularText, Row, SizedBox } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

export const TicketTab = ({ value, onChange }: { value: number; onChange: (index: number) => void }) => {
  const { t } = useTranslation();

  return (
    <Row
      padding={pixelScaler(3)}
      backgroundColor={AppColors.tabbarBackground}
      borderRadius={metrics.borderRadius}
      marginHorizontal={metrics.large}
      marginBottom={metrics.large}>
      <TicketItem text={t('departureTripTab')} isActive={value === 0} onPress={() => onChange(0)} />
      <SizedBox width={metrics.medium} />
      <TicketItem text={t('returnTripTab')} isActive={value === 1} onPress={() => onChange(1)} />
    </Row>
  );
};

const TicketItem = ({ text, isActive, onPress }: { text: string; isActive: boolean; onPress: () => void }) => {
  return (
    <TouchableOpacity style={{ flex: 1 }} activeOpacity={0.8} onPress={onPress}>
      <Container
        borderRadius={metrics.borderRadius}
        align="center"
        backgroundColor={isActive ? AppColors.white : 'transparent'}
        height={40}
        width="100%">
        <RegularText fontWeight="bold" color={isActive ? AppColors.black : AppColors.white}>
          {text}
        </RegularText>
      </Container>
    </TouchableOpacity>
  );
};
